module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "holder",
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    staticClass: "navigation",
    staticStyle: {
      "overflow-y": "scroll"
    },
    attrs: {
      "title": ""
    }
  }, [_c('h4', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.selectedRackName) + "\n    ")]), _vm._v(" "), _c('div', {
    ref: "table",
    staticClass: "table"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.products), function(product) {
    return _c('tr', {
      class: {
        'anti-facing': product.noFacing
      }
    }, [_c('td', {
      staticClass: "id"
    }, [_vm._v(_vm._s(product.groupId))]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('td', {
      staticClass: "title"
    }, [_vm._v(_vm._s(product.title) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "group"
    }, [_vm._v(_vm._s(product.cluster ? product.cluster.title : ''))])])
  }), 0)]), _vm._v(" "), (_vm.hasNext) ? _c('a', {
    ref: "nextLink",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loadNextPage.apply(null, arguments)
      }
    }
  }, [_vm._v("Еще товары")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "editor-field",
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    staticClass: "plan-holder",
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    staticClass: "added-racks",
    attrs: {
      "title": ""
    }
  }, _vm._l((_vm.racks), function(rack) {
    return _c('rack-on-plan', {
      attrs: {
        "width": rack.prototype.width,
        "height": rack.prototype.height,
        "depth": rack.prototype.depth,
        "left": rack.startX,
        "top": rack.startY,
        "angle": rack.angle,
        "id": rack.id,
        "title": rack.title,
        "selected": rack.selected,
        "fulfillment": rack.workload,
        "isExt": rack.isExt
      },
      on: {
        "mousedown": _vm.rackClicked,
        "dblclick": _vm.rackDblClicked
      }
    })
  }), 1), _vm._v(" "), _c('svg', [_c('g', [_c('path', {
    attrs: {
      "d": _vm.contour
    }
  }), _vm._v(" "), _vm._l((_vm.partitions), function(partition, index) {
    return _c('path', {
      attrs: {
        "d": partition.str
      }
    })
  })], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', {
    staticClass: "id"
  }, [_vm._v("\n            ID\n\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "photo"
  }, [_vm._v("Фото")]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("\n            Название\n\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "group"
  }, [_vm._v("\n            Кластер\n\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "photo"
  }, [_c('div', {
    staticClass: "photo-item"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29af526a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pharmacy/PharmacyInfo.vue
// module id = 234
// module chunks = 1